import { CATEGORIES, ACTIONS, LABELS } from "../types";

/**
 * Register Screen.
 */
const REGISTER_EVENTS = {
  FINNISH_CLOUD_REGISTER: {
    category: CATEGORIES.REGISTER,
    action: ACTIONS.FINNISH_CLOUD_REGISTER,
  },
};

/**
 * Login Screen.
 */
const LOGIN_EVENTS = {
  GOOGLE_LOGIN: {
    category: CATEGORIES.LOGIN,
    action: ACTIONS.GOOGLE_LOGIN,
  },
  LOGIN_SUCCESS: {
    category: CATEGORIES.LOGIN,
    action: ACTIONS.LOGIN_SUCCESS,
  },
};

/**
 * Shippers Screen.
 */
const SHIPPER_EVENTS = {
  VIEW_PROFILE: {
    category: CATEGORIES.SHIPPERS,
    action: ACTIONS.VIEW_PROFILE,
  },
  INVITE_LINK: {
    category: CATEGORIES.SHIPPERS,
    action: ACTIONS.INVITE_LINK,
  },
  ENROLL_SHIPPER_MODAL_CANCEL: {
    category: CATEGORIES.SHIPPERS,
    action: ACTIONS.CANCEL,
    label: LABELS.ENROLL_SHIPPER_MODAL,
  },
  ENROLL_SHIPPER_MODAL_DECLINE: {
    category: CATEGORIES.SHIPPERS,
    action: ACTIONS.DECLINE_SHIPPER,
    label: LABELS.ENROLL_SHIPPER_MODAL,
  },
  ENROLL_SHIPPER_MODAL_ENROLL: {
    category: CATEGORIES.SHIPPERS,
    action: ACTIONS.ENROLL_SHIPPER,
    label: LABELS.ENROLL_SHIPPER_MODAL,
  },
  FILTER_BUTTON: {
    category: CATEGORIES.SHIPPERS,
    action: ACTIONS.FILTER_BUTTON,
  },
  SEARCHING_BY_TEXT: {
    category: CATEGORIES.SHIPPERS,
    action: ACTIONS.SEARCHING_BY_TEXT,
  },
};

/**
 * My Profile Screen.
 */
const PROFILE_EVENTS = {
  BACK_BUTTON: {
    category: CATEGORIES.PROFILE,
    action: ACTIONS.BACK_BUTTON,
  },
  LOGOUT: {
    category: CATEGORIES.PROFILE,
    action: ACTIONS.LOGOUT,
  },
  SAVE: {
    category: CATEGORIES.PROFILE,
    action: ACTIONS.SAVE,
    label: LABELS.UPDATE_PROFILE_DATA,
  },
  SWITCH_PERSONAL_TAB: {
    category: CATEGORIES.PROFILE,
    action: ACTIONS.SWITCH_TAB,
    label: LABELS.PERSONAL_DATA,
  },
  SWITCH_CLOUD_TAB: {
    category: CATEGORIES.PROFILE,
    action: ACTIONS.SWITCH_TAB,
    label: LABELS.CLOUD_DATA,
  },
};

/**
 * Mobile Menu.
 */
const MOBILE_MENU_EVENTS = {
  VIEW_PROFILE: {
    category: CATEGORIES.MOBILE_MENU,
    action: ACTIONS.VIEW_PROFILE,
  },
  LOGOUT: {
    category: CATEGORIES.MOBILE_MENU,
    action: ACTIONS.LOGOUT,
  },
  WHATSAPP: {
    category: CATEGORIES.MOBILE_MENU,
    action: ACTIONS.WHATSAPP,
  },
};

/**
 * Landing Page
 */
const LANDING_PAGE_EVENTS = {
  LOGIN: {
    category: CATEGORIES.LANDING_PAGE,
    action: ACTIONS.LOGIN,
  },
  REGISTER: {
    category: CATEGORIES.LANDING_PAGE,
    action: ACTIONS.REGISTER,
  },
  WHATSAPP: {
    category: CATEGORIES.LANDING_PAGE,
    action: ACTIONS.WHATSAPP,
  },
};

/**
 * New Shipper Landing
 */
const NEW_SHIPPER_LANDING_EVENTS = {
  DOWNLOAD_ANDROID_APP: {
    category: CATEGORIES.NEW_SHIPPER_LANDING,
    action: ACTIONS.APP_DOWNLOAD,
    label: LABELS.ANDROID,
  },
  DOWNLOAD_IOS_APP: {
    category: CATEGORIES.NEW_SHIPPER_LANDING,
    action: ACTIONS.APP_DOWNLOAD,
    label: LABELS.IOS,
  },
};

const GA_EVENTS = {
  REGISTER: REGISTER_EVENTS,
  LOGIN: LOGIN_EVENTS,
  SHIPPERS: SHIPPER_EVENTS,
  PROFILE: PROFILE_EVENTS,
  MOBILE_MENU: MOBILE_MENU_EVENTS,
  LANDING_PAGE: LANDING_PAGE_EVENTS,
  NEW_SHIPPER_LANDING: NEW_SHIPPER_LANDING_EVENTS,
};

export { GA_EVENTS };
